// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ef7382bc","977":"e9b2a4b5"}[chunkId] + ".chunk.js";
};